import { environment } from 'src/environments/environment';

/// The brand, from environment*.ts - the one place the app names it. The company behind it (legal name, address,
/// mailbox) is the server's Company section, read through CompanyService; nothing here repeats it.
export const BRAND: { name: string; domain: string; tagline: string } = (environment as any).brand;

/// The site's own address, no trailing slash: canonical links, share links and structured data.
export const SITE_ORIGIN = 'https://' + BRAND.domain;
